import { createPinia } from 'pinia'
const pinia = createPinia()
export default pinia
export * from './user'
export * from './navlist'
export * from './other'
export * from './layout'
export * from './order'
